/* eslint-disable react/jsx-pascal-case */
import React, { useRef, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import AppFormikInputFieldRadio from "utlis/helpers/forms/AppFormikInputFieldRadio";
import FeatherIcon from "feather-icons-react";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { ERROR_WHILE__NAME } from "utlis/AppMessages/AppMessages";
import { UNKNOWN_ERROR_OCCURED } from "utlis/AppMessages/AppMessages";
import { addCustomer, getCustomerAddresses, } from "utlis/Apis/Customers_API";
import FormSaleOrders__CustomerInfo from "./FormCustomerInformation/FormSaleOrders__CustomerInfo";
import FormSaleOrdersShippingAddress from "./FormCustomerInformation/FormSaleOrdersShippingAddress";
import FormSaleOrdersBillingAddress from "./FormCustomerInformation/FormSaleOrdersShippingAddress";
import { CUSTOMER_ADDED_SUCCESSFULLY } from "utlis/AppMessages/AppMessages";
import { ERROR_WHILE_CREATING_CUSTOMER } from "utlis/AppMessages/AppMessages";
import { useFormik } from "formik";
import { createCustomerIntialValues, createAddressIntialValues, createCustomerVS, createAddressVS } from "./Helper";

function SaleOrdersFormCustomerInfoView(props) {
  const { authState, customer, setCustomer, customerGroups, countries, customers, getCustomers, resetAll,
    bAddress, sAddress, setBAddress, setSAddress, setAddresses, addresses, saveAddresses } = props
  const submitButtonRef = useRef(null)
  const sAddressButtonRef = useRef(null)
  const bAddressButtonRef = useRef(null)
  const [first_name, setFirst_name] = useState(' ');
  const [email, setEmail] = useState('');
  const [foundCustomers, setFoundCustomers] = useState(false);
  const [createButtonLoading, setCreateButtonLoading] = useState(false)

  const goStep1 = () => {
    if (customer.isNew) {
      window.scrollTo(0, 0)
      submitButtonRef.current.click()
    } else if (!customer.user_id) {
      window.scrollTo(0, 0)
      toast.error("Please select or create a customer")
    } else {
      bAddressButtonRef.current.scrollIntoView()
      bAddressButtonRef.current.click()
      if (!aformik.values.same) {
        // sAddressButtonRef.current.click()
      }
    }
  }
  const next = (addressB, addressS) => {
    if (customer.user_id) {
      props.setGoSteps(1)
      saveAddresses(addressB, addressS)
    } else {
      onCreateFormSubmit(customer)
    }
  }

  const getCustomerAddresses_ = (user_id) => {
    if (!user_id) {
      return
    }
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCustomerAddresses(headers, user_id).then(res => {
      const addressData = res.data
      if (addressData.success) {
        setAddresses(arr => addressData.data)
        setBAddress(addressData.data.filter(e => e.is_default && e.address_type === "Billing")[0] || addressData.data.filter(e => e.address_type === "Billing")[0] || {})
        setSAddress(addressData.data.filter(e => e.is_default && e.address_type === "Shipping")[0] || addressData.data.filter(e => e.address_type === "Shipping")[0] || {})

      }
      if (addressData.error) {
        console.log('Error occured while loading admin groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getAddresses `, err.message)
    })
  }


  const filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== '') {
      const results = customers.filter((customer) => {
        return customer.first_name.toLowerCase().startsWith(keyword.toLowerCase()) ||
          customer.email.toLowerCase().startsWith(keyword.toLowerCase());
      });
      setFoundCustomers(results)
    } else {
      setFoundCustomers(false);
      // setBAddress(addresses);
    }
    setFirst_name(keyword);
    setEmail(keyword);
  };


  const onCreateFormSubmit = values => {
    if (values) {
      setGlobalLoading(true)
      setCreateButtonLoading(true)
      const headers = {
        "Authorization": `Bearer ${authState.commonToken}`,
        "Api-Token": authState.apiToken,
        "Access-Token": "",
        // "Store-Id": authState.storeId,
      }
      addCustomer(headers, values).then(res => {
        setGlobalLoading(false)
        const addingCustomer = res.data
        if (addingCustomer.success) {
          values.user_id = res.data.user_id
          onSuccess(values)
        } else if (addingCustomer.error) {
          onError(addingCustomer)
        }
      }).catch(err => {
        console.log(`${ERROR_WHILE__NAME} createCustomer `, err.message)
        onCatch()
      })
    }
  }

  const onError = (res) => {
    let error = ""
    setCreateButtonLoading(false)
    if (typeof res.message === 'string' || res.message instanceof String) {
      error = res.message
    } else {
      Object.keys(res.message).forEach(function (key) {
        error = error + res.message[key] + " "
      });
    }
    toast.dismiss();
    toast.error(error || ERROR_WHILE_CREATING_CUSTOMER, {
      autoClose: 3000,
    })
  }
  const onCatch = () => {
    toast.dismiss();
    toast.error(UNKNOWN_ERROR_OCCURED, {
      autoClose: 2500,
      onClose: () => {
        setGlobalLoading(false)
        setCreateButtonLoading(false)
      }
    })

  }
  const onSuccess = (data) => {
    getCustomers()
    setCreateButtonLoading(false)
    data.isNew = false
    setCustomer(data)
    cformik.resetForm()
    setAddresses(arr => [])
    setSAddress({})
    setBAddress({})

    // props.setGoSteps(1)
    toast.dismiss();
    toast.success(CUSTOMER_ADDED_SUCCESSFULLY, {
      autoClose: 2000,
      onClose: () => {
      }
    })
  }
  const handleFormSubmission = (ev) => {
    ev.preventDefault()
    submitButtonRef.current.click()
  }

  const cformik = useFormik({
    initialValues: { ...createCustomerIntialValues({}) },
    validationSchema: createCustomerVS,
    // onSubmit: (customer_) => {
    //   setCustomer(customer_)
    //   console.log("111")
    //   // bAddressButtonRef.current.click()
    // },
    onSubmit: onCreateFormSubmit,
    enableReinitialize: false,
    initialTouched: {}
  })

  const sformik = useFormik({
    initialValues: (!customer.user_id || customer.isNew) ? {} : {
      ...createAddressIntialValues, ...sAddress, shipping_first_name: customer.first_name,
      shipping_last_name: customer.last_name, shipping_middle_name: customer.middle_name,
      shipping_company_name: customer.company_name
    },
    validationSchema: createAddressVS,
    onSubmit: (address) => {
      setSAddress(address)
      next(bAddress, address)
    },
    enableReinitialize: true,
    validate: () => {
      // setSame(false)
    }
  })
  const _formik = useFormik({
    initialValues: createAddressIntialValues,
    validationSchema: createAddressVS,
    onSubmit: (address) => { },
    enableReinitialize: true,
  })
  const aformik = useFormik({
    initialValues: {
      ...createAddressIntialValues, shipping_first_name: customer.first_name,
      shipping_last_name: customer.last_name, shipping_middle_name: customer.middle_name, shipping_company_name: customer.company_name,
      ...bAddress
    },
    validationSchema: createAddressVS,
    onSubmit: (address) => {
      console.log(">>>", "11")

      setBAddress(address)
      if (address.same) {
        setSAddress(address)
        next(address)
      } else {
        sAddressButtonRef.current.click()
      }
    },
    enableReinitialize: true,
    validate: (values) => {
      // setBAddress(values)
      // setSame(false)
    }
  })

  return (
    <React.Fragment>
      <div id="sale-order-venderInfo">
        <div
          className="venderInfo-card">
          <div
            className="app-header-wrapper heading-sm mb-1">
            <p className="app-heading-bold text-capitalize app-heading-label">
              Customer Information
            </p>
          </div>

          <div className="sale-order-for border st-border-light st-default-rounded-block pad-20-LR pad-20-T pad-20-B">
            <Col
              xs={12}
              md={9}
              lg={!customer.isNew ? 6 : 12}
              className="px-0"
            >
              <form onSubmit={cformik.handleSubmit} noValidate autoComplete="off">
                <FormSaleOrders__CustomerInfo
                  formik={cformik}
                  selectedCustomer={customer}
                  customers={customers}
                  customerGroups={customerGroups}
                  first_name={first_name}
                  email={email}
                  foundCustomers={foundCustomers}
                  filter={filter}
                  setFoundCustomers={bool => setFoundCustomers(bool)}
                  setSelectedCustomer_={setCustomer}
                  addresses={addresses}
                  getCustomerAddresses_={getCustomerAddresses_}
                  bAddress={bAddress}
                  sAddress={sAddress}
                  setBAddress={bool => {
                    setBAddress(bool)
                  }}
                  setSAddress={bool => { setSAddress(bool) }}
                  setAddresses={setAddresses}
                  resetAddress={() => {
                    aformik.resetForm()
                    sformik.resetForm()
                  }}
                />
                <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
              </form>
              {customer.isNew &&
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={handleFormSubmission}
                    disabled={createButtonLoading}
                    className={`st-btn  st-btn-primary st-btn-sm   d-flex align-items-center justify-content-center`}
                  >
                    {
                      createButtonLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <span>Save Customer</span>
                      )
                    }
                  </button>
                </div>
              }
            </Col>
          </div>
        </div>

        <Row className="customerInfo-addresses">
          <div className="app-card mb-3 mb-lg-4" style={{ width: "50%", paddingRight: 7.5, paddingLeft: 0 }}>
            <Row>
              <Col xs={12} md={9} lg={12} className="px-0">
                <div
                  className="app-header-aaddresses heading-sm pad-12-L" style={{ marginBottom: 12.5 }}>
                  <p>Billing Address</p>
                </div>
              </Col>
            </Row>

            <div className="app-card-content border st-border-light st-default-rounded-block pad-20-LR pad-20-T billing-address">
              <Col xs={12} md={9} lg={12} className="px-0">
                <form onSubmit={aformik.handleSubmit} noValidate autoComplete="off">
                  <button type="submit" ref={bAddressButtonRef} className="d-none">submit</button>
                  <FormSaleOrdersBillingAddress
                    formik={(!customer.user_id || customer.isNew) ? _formik : aformik}
                    countries={countries}
                    isDisabled={(!customer.user_id || customer.isNew)}
                  />
                </form>
              </Col>
            </div>
          </div>

          <div className="app-card mb-3 mb-lg-4 app-shipping-content" style={{ width: "50%", paddingLeft: 7.5, paddingRight: 0 }}>
            <Row style={{ marginBottom: "-24px" }}>
              <Col xs={12} md={9} lg={7} className="px-0">
                <div className="app-header-addresses heading-sm" style={{ marginBottom: 36 }}>
                  <p>Shipping Address</p>
                </div>
              </Col>
              <Col xs={12} md={9} lg={5} className="px-0">
                <div className="app-header-wrapper heading-sm"
                  style={{ float: "right" }}>
                  <AppFormikInputFieldRadio
                    stFormClass={
                      "st-form st-form-with-label-left d-flex flex-wrap align-items-center pb-0 same-as-billing"
                    }
                    formikFieldName={"sameAsBillingAddress"}
                    labelNameRight={"Same as Billing Address"}
                    isRound={true}
                    value={aformik.values.same || false}
                    onChange={e => {
                      aformik.setFieldValue("same", e.target.checked)
                    }}
                  />
                </div>
              </Col>
            </Row>

            <div className="app-card-content border st-border-light st-default-rounded-block pad-20-LR pad-20-T shipping-address">
              <Col xs={12} md={9} lg={12} className="px-0">
                <form onSubmit={sformik.handleSubmit} noValidate autoComplete="off">
                  <FormSaleOrdersShippingAddress
                    authState={authState}
                    formik={(!customer.user_id || customer.isNew) ? _formik :
                      (aformik.values.same ? aformik : sformik)}
                    countries={countries}
                    isDisabled={(!customer.user_id || (customer.isNew || aformik.values.same))}
                  />
                  <button type="submit" ref={sAddressButtonRef} className="d-none">submit</button>
                </form>
              </Col>
            </div>
          </div>
          <div className="app-card-content bg-white  d-flex align-items-center justify-content-end bottom-btn">
            <button
              type="button"
              className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2`}
              disabled={createButtonLoading}
              onClick={() => {
                resetAll()
                aformik.resetForm()
                sformik.resetForm()
                cformik.resetForm()
                _formik.resetForm()
              }}
            >
              {
                createButtonLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <span>Reset</span>
                )}
            </button>

            <button
              type="submit"
              className={`st-btn  st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center`}
              disabled={createButtonLoading}
              onClick={() => {
                goStep1()
              }}
            >
              {createButtonLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <span>Next</span>
                  <FeatherIcon
                    icon="arrow-right"
                    size="14"
                    className="icon ms-1"
                  />
                </>
              )}
            </button>
          </div>

        </Row>
      </div >
    </React.Fragment >
  );
}


const getDataFromStore = state => {
  return {
    authState: state.auth,
  };
}

const dispatchActionsToProps = dispatch => {
  return {
    setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
  }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SaleOrdersFormCustomerInfoView)